function stripLastPathSegment(path, times = 1) {
  return path
    .split('/')
    .slice(0, -times)
    .join('/');
}

export default stripLastPathSegment;
